module.exports = __webpack_public_path__ + "static/assets/a4d91e3b83e7cbccaf4a4e2322b873f5.svg";